import { ConfettiAnimation } from "@expert/sales-tools";
import { Container, LoadingOverlay, Stack } from "@mantine/core";
import { useTimeout } from "@mantine/hooks";
import { useState } from "react";

import type { ChatTask } from "@/sdk/agent/chat";

import { LoadingAnimation } from "@/common-ui/icons/sales"; //TODO: move to common-ui

import ChatMessagesContainer from "./ChatMessagesContainer";
import { NoActiveChatView } from "./NoActiveChatView";

export function ChatPanelTimelineView({ activeChatTask }: { activeChatTask?: ChatTask }) {
    /***
     * TODO: (EWPM-538) Explore if we can suspense the visibility base on "get messages" or
     * some other kind of loading the chat details, instead of base on arbitrary time.
     * In the meanwhile, this behavior is sufficient to simulate the design planned experience.
     * https://solutonashville.atlassian.net/browse/EWPM-538
     * */
    const [isConversationDataLoading, setIsConversationDataLoading] = useState(true);
    // Mantine's useTimeout hook to simulate twilio conversation data loading delay
    useTimeout(() => setIsConversationDataLoading(false), 1500, { autoInvoke: true });

    return (
        <Stack h="100%" w="100%" id="active-chat-view" gap={0} pos="absolute">
            {!activeChatTask || activeChatTask.status === "pending" ? (
                <NoActiveChatView />
            ) : (
                <ChatMessagesContainer activeChatTask={activeChatTask} />
            )}

            <LoadingOverlay
                visible={isConversationDataLoading && activeChatTask && activeChatTask.status !== "pending"}
                loaderProps={{
                    children: (
                        <Container maw="50%">
                            <LoadingAnimation />
                        </Container>
                    ),
                }}
                overlayProps={{
                    backgroundOpacity: 1,
                    color: "var(--exwo-color-app-bg)",
                }}
            />

            {/* The key prop here is used to reset the confetti animation when the chat task changes */}
            <Container w="100%" pos="fixed" style={{ pointerEvents: "none" }} key={activeChatTask?.chatId}>
                <ConfettiAnimation />
            </Container>
        </Stack>
    );
}
